import { addMessages } from '@hana/i18n';

// Khoá chuỗi của Mov › Chuyến của tôi (MovHome.tsx). Dữ liệu chuyến, trạng thái, mã cont không dịch.
addMessages('vi', {
  'mvh.open': 'Mở chuyến {n}', 'mvh.time': 'Giờ {v}', 'mvh.title': 'Chuyến của tôi', 'mvh.date': 'Thứ Năm, 22/Oct/2026', 'mvh.day': 'Ngày',
  'mvh.d.yest': 'Hôm qua', 'mvh.d.today': 'Hôm nay', 'mvh.d.tmr': 'Ngày mai',
  'mvh.offB': 'Mất mạng — đang dùng dữ liệu đã lưu', 'mvh.offT': 'Bấm bước, ảnh, chi phí vẫn ghi trên máy và tự gửi khi có sóng. Đang chờ gửi: 2 ảnh · 1 khoản chi.',
  'mvh.npT': 'Tài khoản chưa được gán xe', 'mvh.emT': 'Hôm nay chưa có chuyến',
  'mvh.npD': 'Điều độ gán xe và chuyến cho bạn. Gọi điều độ đang trực để được gán.', 'mvh.emD': 'Điều độ gán chuyến xong sẽ báo về máy.',
  'mvh.mooc': 'Mooc {v}', 'mvh.call': 'Gọi điều độ trực · {d}',
});
addMessages('en', {
  'mvh.open': 'Open trip {n}', 'mvh.time': 'Time {v}', 'mvh.title': 'My trips', 'mvh.date': 'Thursday, 22/Oct/2026', 'mvh.day': 'Day',
  'mvh.d.yest': 'Yesterday', 'mvh.d.today': 'Today', 'mvh.d.tmr': 'Tomorrow',
  'mvh.offB': 'Offline — using saved data', 'mvh.offT': 'Steps, photos and costs are still saved on the device and sent when signal returns. Pending: 2 photos · 1 expense.',
  'mvh.npT': 'No vehicle assigned to this account', 'mvh.emT': 'No trips today',
  'mvh.npD': 'Dispatch assigns a vehicle and trips to you. Call the dispatcher on duty to get assigned.', 'mvh.emD': 'You will be notified once dispatch assigns a trip.',
  'mvh.mooc': 'Trailer {v}', 'mvh.call': 'Call dispatcher on duty · {d}',
});
